export const ZIndex = {
  Notifications: 10000,
  DevTools: 9999,
  Overlays: 1000,
  StickyHeaders: 999,
}
